<script>
    export default {
        props: {
            details: String
        }
    } 
</script>

<template>
    <div class="bg-primary bg-soft">
        <div class="row">
            <div class="col-7">
                <div class="text-primary p-4">
                    <h5 class="text-primary">
                        Intake Form
                    </h5>
                    <p>Please Complete the Form Below</p>
                </div>
            </div>
            <div class="col-5 align-self-center p-4">
                <p class="text-primary">
                    {{ details }}
                </p>
            </div>
        </div>
    </div>
</template>